import { basicFetch, GenericObject } from "../services/Price";

// type OrderingParams = {
//   ordering?: { columnIndex: number; direction: "asc" | "desc" }[];
// };

type OrderingDjangoParams = {
  ordering?: string[];
};

// type PaginationParams = {
//   page?: number;
//   pageSize?: number;
// };

type PaginationDjangoParams = {
  page?: number;
  page_size?: number;
};
// type Params = OrderingParams & PaginationDjangoParams & GenericObject;
type DjangoParams = OrderingDjangoParams &
  PaginationDjangoParams &
  GenericObject;

export const getTableData = async (
  apiUrl: string,
  params?: DjangoParams,
  options?: GenericObject
) => {
  return basicFetch<GenericObject, DjangoParams>(apiUrl, params, options);
};
